<template>
  <div>
    <div class="title">如何申请发票？</div>
    <div class="content-info">
      <p class="txt1">进入“我的”界面，点击常用工具中的“我的发票“按钮，进入开票页面填写发票信息提交申请。</p>
      <ul>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/4991fd8f5aadd3b71dbf18226cd48798.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/58166e9736fe79a58aca665e800e32f7.png" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
